import api from './api'

export const fichaService = {
  async getAll(params = {}) {
    const response = await api.get('/fichas', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/fichas/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post('/fichas', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/fichas/${id}`, data)
    return response.data
  },

  async getTratamientos(id) {
    const response = await api.get(`/fichas/${id}/tratamientos`)
    return response.data
  },

  async addTratamiento(id, data) {
    const response = await api.post(`/fichas/${id}/tratamientos`, data)
    return response.data
  },

  async getSeguimientos(id) {
    const response = await api.get(`/fichas/${id}/seguimientos`)
    return response.data
  },

  async addSeguimiento(id, data) {
    const response = await api.post(`/fichas/${id}/seguimientos`, data)
    return response.data
  },

  // Descargar PDF de la ficha clínica
  async descargarPDF(id) {
    try {
      const response = await api.get(`/fichas/${id}/pdf`, {
        responseType: 'blob' // Importante para descargar archivos
      })
      
      // Verificar el tipo de contenido
      const contentType = response.headers['content-type'] || ''
      
      // Si la respuesta es JSON (error), parsearlo
      if (contentType.includes('application/json') || response.data.type === 'application/json') {
        const text = await response.data.text()
        try {
          const errorData = JSON.parse(text)
          throw new Error(errorData.error || 'Error al generar el PDF')
        } catch (parseError) {
          throw new Error('Error al generar el PDF. Por favor, intente nuevamente.')
        }
      }
      
      // Verificar que sea un PDF válido
      if (!contentType.includes('application/pdf') && response.data.size < 100) {
        // Si el tamaño es muy pequeño, probablemente es un error
        const text = await response.data.text()
        try {
          const errorData = JSON.parse(text)
          throw new Error(errorData.error || 'Error al generar el PDF')
        } catch (parseError) {
          // Si no es JSON, verificar si tiene contenido de error
          if (text.includes('error') || text.includes('Error')) {
            throw new Error('Error al generar el PDF')
          }
        }
      }
      
      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = url
      
      // Obtener el nombre del archivo del header Content-Disposition si está disponible
      const contentDisposition = response.headers['content-disposition']
      let filename = `ficha-clinica-${id}.pdf`
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i)
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '')
          // Decodificar si está codificado
          if (filename.includes('%')) {
            filename = decodeURIComponent(filename)
          }
        }
      }
      
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      
      return { success: true, message: 'PDF descargado exitosamente' }
    } catch (error) {
      // Si el error viene de axios, extraer el mensaje
      if (error.response) {
        // Si es un blob, intentar parsearlo
        if (error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text()
            const errorData = JSON.parse(text)
            throw new Error(errorData.error || 'Error al generar el PDF')
          } catch (parseError) {
            // Si no es JSON, puede ser un error de red
            if (error.response.status === 404) {
              throw new Error('Ficha clínica no encontrada')
            } else if (error.response.status === 403) {
              throw new Error('No tienes permisos para descargar esta ficha')
            } else if (error.response.status === 500) {
              throw new Error('Error del servidor al generar el PDF. Por favor, intente nuevamente.')
            }
            throw new Error('Error al generar el PDF. Por favor, intente nuevamente.')
          }
        }
        // Si es un objeto de error directo
        if (error.response.data?.error) {
          throw new Error(error.response.data.error)
        }
        throw new Error(error.message || 'Error al descargar el PDF')
      }
      // Si es un error de red o otro tipo
      if (error.message) {
        throw error
      }
      throw new Error('Error de conexión. Por favor, verifique su conexión a internet.')
    }
  },
}

